import { createStore } from 'satcheljs';
export default createStore('skypeOption', {
    imNotification: null,
    callNotification: null,
});
//# sourceMappingURL=store.js.map